module.exports = __webpack_public_path__ + "static/media/silver-car-wheel.a14f8207.webp";